import { defineStore } from 'pinia'
import MyInvoicesStore, { MyInvoicesState } from '@/modules/myInvoices/types/store/MyInvoicesStore'

export const useMyInvoicesStore: MyInvoicesStore = defineStore('invoices', {
  state: () =>
    ({
      invoiceCollection: null,
      activeStatus: null,
    }) as MyInvoicesState,
  getters: {
    getInvoicesList(state) {
      return state.invoiceCollection?.invoices || []
    },
    getTotalresults(state) {
      return state.invoiceCollection?.totalresults || 0
    },
    getHasUnpaidInvoices(state) {
      return state.invoiceCollection?.hasUnpaidInvoices || false
    },
    getStatusCounts(state) {
      return state.invoiceCollection?.statusCounts || {}
    },
    /* The register is re-created on every visit, so the tab has to be remembered outside it —
       otherwise coming back from an invoice drops the customer on the default tab rather than
       the one they left. `null` means no tab has been resolved yet this session. */
    getActiveStatus(state) {
      return state.activeStatus
    },
  },
  actions: {
    async getInvoices({ startnumber, numreturned, orderby, order, status }) {
      const response = await this.$services.myInvoices.loadInvoices({
        startnumber,
        numreturned,
        orderby,
        order,
        status,
      })
      if (response) {
        this.invoiceCollection = response
      }
    },
    setActiveStatus(status: string) {
      this.activeStatus = status
    },
  },
})
